import { nicheByID, nicheCreate, nicheDestroy, nicheList, nicheUpdate } from '@/services/agency/niches.service'

export default {
	namespaced: true,
	state: {
		// SERVICE NICHE
		nicheList: {
			meta: {
				pagination: {
					total: 0,
				},
			},
		},
		niche: {},

		// STATUS SERVICE NICHE
		nicheStatus: 'pending',
		nicheSaveStatus: 'init',
		nicheDeleteStatus: 'init',
	},
	getters: {
		// SERVICE NICHE
		getNicheList(state) {
			return state.nicheList
		},
		getNiche(state) {
			return state.niche
		},

		// SERVICE STATUS
		getStatusList(state) {
			return state.statusList
		},
		getStatus(state) {
			return state.status
		},

		// SERVICE NICHE
		getNicheDeleteStatus(state) {
			return state.nicheDeleteStatus
		},
		getNicheSaveStatus(state) {
			return state.nicheSaveStatus
		},
		getNicheStatus(state) {
			return state.nicheStatus
		},
	},
	mutations: {
		// SERVICE NICHE
		NICHE_LIST(state, value) {
			state.nicheList = value
		},
		SET_NICHE(state, value) {
			state.niche = value
		},

		// STATUS SERVICE NICHE
		NICHE_STATUS(state, value) {
			state.nicheStatus = value
		},
		NICHE_SAVE_STATUS(state, value) {
			state.nicheSaveStatus = value
		},
		NICHE_DELETE_STATUS(state, value) {
			state.nicheDeleteStatus = value
		},
	},
	actions: {
		// Service Niche
		async fetchNicheList({ commit }, params) {
			window.scrollTo({ top: 0, behavior: 'smooth' })
			commit('NICHE_STATUS', 'pending')
			commit('NICHE_LIST', {
				meta: {
					pagination: {
						total: 0,
					},
				},
			})
			try {
				const { data } = await nicheList(params)
				commit('NICHE_STATUS', 'init')
				commit('NICHE_LIST', data)
				return data
			} catch (error) {
				commit('NICHE_STATUS', 'init')
				throw error
			}
		},
		async fetchNicheByID({ commit }, params) {
			commit('NICHE_STATUS', 'pending')
			try {
				const { data } = await nicheByID(params)
				commit('NICHE_STATUS', 'init')
				commit('SET_NICHE', data.data)
				return data
			} catch (error) {
				commit('NICHE_STATUS', 'init')

				return error
			}
		},
		async saveNewNiche({ commit }, params) {
			commit('NICHE_SAVE_STATUS', 'pending')
			try {
				const { data } = await nicheCreate(params)
				commit('NICHE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NICHE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async updateNiche({ commit }, params) {
			commit('NICHE_SAVE_STATUS', 'pending')
			try {
				const { data } = await nicheUpdate(params)
				commit('NICHE_SAVE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NICHE_SAVE_STATUS', 'init')
				throw error
			}
		},
		async deleteNicheByID({ commit }, params) {
			commit('NICHE_DELETE_STATUS', 'pending')
			try {
				const { data } = await nicheDestroy(params)
				commit('NICHE_DELETE_STATUS', 'init')
				return data
			} catch (error) {
				commit('NICHE_DELETE_STATUS', 'error')

				return error
			}
		},
	},
}
